<template>
    <div class="release margin-bottom-xbig">
        <b-collapse ref="collapse" :startOpen="true" @collapse="rotate='2x'" @expand="rotate=''">
            <div class="header infos margin-bottom-big" ref="releaseInfos" slot="title">
                <div class="title display-flex align-content-center align-items-center">
                    <div 
                        tabindex="0" 
                        @click="$refs.deleteReleaseModal.toggleModal();"
                        @keydown.enter.prevent="$refs.deleteReleaseModal.toggleModal();"
                        class="font-size-big remove-release padding-horizontal-tiny negative-margin-top-tiny">
                        <b-icon><icon-delete /></b-icon>
                    </div>  
                    <b-text-input 
                    name="releaseName" 
                    @input="editRelease($event)" 
                    autosize 
                    inputClasses="font-size-xxbig bg-transparent border border-transparent bg-hover-white-darker-2 bg-focus-white-darker-2 border-hover-ink-lighter-3 border-focus-ink-lighter-3 padding-horizontal-tiny padding-vertical-tiny negative-margin-left-tiny" 
                    :value="release.name"
                    @keydown.native.enter.prevent="$event.target.blur()"/>
                </div>
                <div class="front-end margin-left-auto tag-infos align-right">
                    <p class="small ink-lighter-1 margin-vertical-xxtiny">Front-end</p>
                    <p class="small ink-base margin-vertical-xxtiny">{{ $store.getters.storyPointsInReleaseByTag(release.id, 'Front-end') }} story points</p>
                    <p class="small ink-base semi-bold margin-vertical-xxtiny">{{ $store.getters.estimatedTimeInReleaseByTag(release.id, 'Front-end') }} dias</p>
                </div>
                <div class="back-end margin-left-big tag-infos align-right">
                    <p class="small ink-lighter-1 margin-vertical-xxtiny">Back-end</p>
                    <p class="small ink-base margin-vertical-xxtiny">{{ $store.getters.storyPointsInReleaseByTag(release.id, 'Back-end') }} story points</p>
                    <p class="small ink-base semi-bold margin-vertical-xxtiny">{{ $store.getters.estimatedTimeInReleaseByTag(release.id, 'Back-end') }} dias</p>
                </div>
                <div class="back-end margin-left-big tag-infos align-right">
                    <p class="small ink-lighter-1 margin-vertical-xxtiny">Total</p>
                    <p class="small ink-base margin-vertical-xxtiny">{{ $store.getters.storyPointsInReleaseByTag(projectId, release.id, 'Front-end') + $store.getters.storyPointsInReleaseByTag(release.id, 'Back-end') }} story points</p>
                    <p class="small ink-base semi-bold margin-vertical-xxtiny">{{ Math.max($store.getters.estimatedTimeInReleaseByTag(release.id, 'Front-end'), $store.getters.estimatedTimeInReleaseByTag(release.id, 'Back-end')) }} dias</p>
                </div>
                <div class="display-flex justify-content-center margin-left-big flex-column">
                    <b-icon tabindex='0'
                    @click.native="$refs.collapse.toggle()"
                    @keydown.enter.native="$refs.collapse.toggle()" :rotate="rotate">
                        <icon-chevron-down class="chevron-down top-big font-size-huge"/>
                    </b-icon>
                </div>
                <!-- <div class="display-flex justify-content-center margin-left-big flex-column">
                    <b-icon tabindex='0' @click.native="doSomething()"
                        :rotate="rotate">
                        <icon-chevron-down class="chevron-down top-big font-size-huge"/>
                    </b-icon>
                </div> -->
            </div>
            <!-- <b-card class="stories" v-collapsible="false" ref="stories" @collapse="rotate='2x'" @expand="rotate=''"> -->
            <b-card class="stories" ref="stories">
                <ul class="padding-0 margin-0">
                    <li class="padding-left-big padding-right-xbig padding-vertical-normal">
                        <div>
                            <p class="small semi-bold margin-top-xtiny margin-bottom-0">
                                Stories
                            </p>
                        </div>
                        <div class="margin-left-auto">
                            <p class="small semi-bold margin-top-xtiny margin-bottom-0">
                                Story Points
                            </p>
                        </div>
                    </li>
                    <app-story v-for="story in release.stories" :story="story" :releaseId="release.id" :key="story.id" @addstory="addStory" />
                    <li class="padding-horizontal-big padding-vertical-normal border-top border-ink-lighter-3">
                        <a 
                        class="small semi-bold blue-base margin-vertical-xxtiny add-new"
                        tabindex="0" @keydown.enter="addStory()" @click="addStory()"
                        >+ Adicionar nova</a>
                    </li>            
                </ul>
            </b-card>
        </b-collapse>
        <b-modal auto ref="deleteReleaseModal">
            Você tem certeza que deseja excluir o {{ release.name }}?
            <div class="display-flex margin-top-normal justify-content-end">
                <b-button 
                outline 
                tiny
                @clickOrEnter="$refs.deleteReleaseModal.hideModal()">
                    Não
                </b-button>
                <b-button
                outline 
                tiny 
                ref="confirmReleaseDelete"
                class="margin-left-normal"
                danger
                @clickOrEnter="removeRelease()">
                    Apagar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import BCard from '@/dls/components/Card.vue';
import AppStory from '@/components/Story.vue';
import BButton from '@/dls/components/Button.vue';
import BModal from '@/dls/components/Modal.vue';
import BIcon from "@/dls/components/Icon.vue";
import IconDelete from "@/dls/icons/icon-delete.svg";
import BCollapse from "@/dls/components/Collapse.vue";
import IconChevronDown from "@/dls/icons/icon-chevron-down.svg";
import BTextInput from "@/dls/components/Input.vue";
import debounce from 'lodash.debounce';

export default {
    name: 'app-release',
    components: {
        BCard, 
        AppStory,
        BModal,
        BButton,
        BIcon,
        BCollapse,
        IconChevronDown,
        IconDelete,
        BTextInput
        },
    props: {
        projectId: Number,
        release: Object
    },
    data() {
        return {window, rotate: ''}
    },
    methods: {
        addStory() {
           this.$store.dispatch('addStoryToRelease', {releaseId: this.release.id, story: {name: '', tags: [], points: 3}});
        },
        editRelease: debounce(function(name) {
                            this.release.name = name;
                            this.$store.dispatch('updateRelease', {release: this.release});
                        }, 350),
        removeRelease: async function() {
            await this.$refs.deleteReleaseModal.hideModal();
            this.$store.dispatch('removeReleaseById', {releaseId: this.release.id});
        }
    }
}
</script>

<style scoped lang="scss">
    .release {
        .infos {
            display: flex;
            justify-content: flex-start;
        }
        .remove-release {
            opacity: 0;
            cursor: pointer;
            &:focus {
                opacity: 1;
            }
        }
        .title {
            position: relative;
        }
        .title:hover .remove-release {
            opacity: 1;
        }
        .remove-release {
            position: absolute;
            left: 0;
            transform: translateX(-100%) translateY(-50%);
            top: 50%;
        }
        .chevron-down {
            cursor: pointer;
        }
    }
    .stories {
        li {
            display: flex;
            list-style: none;
        }
        .add-new {
            cursor: pointer;
        }
    }
</style>